import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);


// Decorate the form component
const LoginForm = withStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  email: {
    marginBottom: 20,
    marginTop: 30,
  },
  error: {
    color: 'red',
    textAlign: 'center',
    width: '100%',
  },
  password: {
    marginBottom: 20,
  },
})(({ classes, error, handleSubmit, pristine, submitting }) => (
  <form onSubmit={handleSubmit} className={classes.container}>
    {error && <Typography variant="subtitle1" className={classes.error}>{error}</Typography>}

    <Field
      className={classes.email}
      name="email"
      component={renderTextField}
      label="E-mailadres"
      fullWidth
    />

    <Field
      className={classes.password}
      name="password"
      type="password"
      component={renderTextField}
      label="Wachtwoord"
      fullWidth
    />

    <Button
      color="primary"
      fullWidth
      variant="contained"
      type="submit"
      disabled={pristine || submitting}
    >
      Inloggen
    </Button>
  </form>
));

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'login' })(LoginForm);
